// Dependencies
import debounce from '../principles/performance/debounce';
import matchViewport from '../principles/responsive/match-viewport';
import requestAnimationFrame from '../principles/performance/requestAnimationFrame';

//

(function () {
  var
  $html = $('html'),
  isEnabled = false,
  isScrolledClass = 'is-scrolled',

  disableAnimation = function () {
    if (!isEnabled) return;
    isEnabled = false;
    $html.removeClass(isScrolledClass);
  },

  enableAnimation = function () {
    if (isEnabled) return;
    isEnabled = true;
    handleOffset();

    $(window).on('scroll', function () {
      requestAnimationFrame(handleOffset);
    });
  },

  handleOffset = function () {
    if (matchViewport('width-xxl')) return;
    $html[(window.pageYOffset > 0 ? 'add' : 'remove' ) + 'Class'](isScrolledClass);
  },

  init = function () {
    if (matchViewport('width-xxl')) {
      disableAnimation();
    } else {
      enableAnimation();
    }
  };

  init();
  $(window).on('resize', debounce(init, 250));
}());



/** WEBPACK FOOTER **
 ** ./~/vt-frontend-engine/app/scripts/components/top-bar.js
 **/